import { P, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { colors } = theme;

export const DisplayValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const PlaceholderText = styled(P)<{ $hasValue: boolean }>`
  color: ${({ $hasValue }) => ($hasValue ? colors.black : colors.grey50)};
  font-size: 1.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Label = styled.span`
  font-size: 0.875rem;
  line-height: 1.5rem;
`;
